import React from "react"

import Banner from "../Banner/Banner"
import Button from "../Button/Button"
import CaptionImage from "../Media/CaptionImage"
import Copy from "../Copy/Copy"
import RichText from "../RichText"
import SidebarMenu from "../Nav/SidebarMenu/SidebarMenu"

import * as m from "../../models/modules"

interface RenderSideModuleProps {
  block: m.SidebarModuleObj
  pageContext: any
}

const defaultProps = {}

export const RenderSideModule: React.FC<RenderSideModuleProps> = props => {
  // console.log("RenderSideModule: ", props.block)
  if (!props.block) return null

  /*************************************
    Banner
  *************************************/
  if (props.block["banner"])
    return (
      <>
        {(props.block["banner"] as m.BannerModule).banner.map(banner => (
          <Banner
            key={banner.id}
            {...banner}
            embed
            pageContext={props.pageContext}
          />
        ))}
      </>
    )

  /*************************************
    Button
  *************************************/
  if (props.block["button"]) {
    const block = props.block["button"] as m.ButtonModule
    if (block?.button)
      // predefined button
      return (
        <div className="embed">
          {block.button.map(button => (
            <Button
              key={button.id}
              {...button}
              pageContext={props.pageContext}
            />
          ))}
        </div>
      )

    return (
      <div className="embed">
        <Button
          label={block.label}
          anchor={block.anchor}
          pageContext={props.pageContext}
        />
      </div>
    )
  }

  /*************************************
    Caption Image
  *************************************/
  if (props.block["image"])
    return (
      <CaptionImage
        {...(props.block["image"] as m.ImageModule)}
        pageContext={props.pageContext}
      />
    )

  /*************************************
    Copy
  *************************************/
  if (props.block["copy"])
    return (
      <>
        {(props.block["copy"] as m.CopyModule).copy.map(copy => (
          <Copy
            key={copy.id}
            content={copy.content}
            cssClass="embed"
            pageContext={props.pageContext}
          />
        ))}
      </>
    )

  /*************************************
    Rich Text
  *************************************/
  if (props.block["rich_text"])
    return (
      <RichText
        content={(props.block["rich_text"] as m.RichTextModule).rich_text}
        cssClass="embed"
        pageContext={props.pageContext}
      />
    )

  /*************************************
    Menu
  *************************************/
  if (props.block["menu"])
    return (
      <>
        {(props.block["menu"] as m.MenuModule).navigation_group.map(menu => (
          <SidebarMenu {...menu} pageContext={props.pageContext} />
        ))}
      </>
    )

  return null
}

RenderSideModule.defaultProps = defaultProps

export default RenderSideModule
